import script from "./BlockPaymentProcessing.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockPaymentProcessing.vue?vue&type=script&setup=true&lang=js"

import "./BlockPaymentProcessing.vue?vue&type=style&index=0&id=2a922228&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a922228"]])

export default __exports__